module.exports = __webpack_public_path__ + "static/media/5.c7581bf0.jpg";